export default {
	white: '#fff',
	sapphire: "#445d87",
	yves: '#002fa7',
	silver: '#F2F2F2',
}
